import Login from './views/Login.vue'//用户登陆
//forgetPwd.vue
import forgetPwd from './views/forgetPwd.vue'
//forgetPwd.vue
import useAgreement from './views/useAgreement.vue'
import checkerLogin from './views/checkerLogin.vue'//管理员登陆
import NotFound from './views/404.vue'
import Home from './views/Home.vue'
import CancelPaper from './views/nav1/cancelPaper.vue'
//import demo from './views/nav1/demo.vue'
import applyRecord from './views/userPages/applyRecord/applyRecord.vue'//申请记录
import viewRecord from './views/userPages/applyRecord/viewRecord.vue'//查看申请记录
import applyCancel from './views/userPages/applyCancel/applyCancel.vue'//提交撤除申请
import viewCancel from './views/userPages/applyCancel/viewCancel.vue'//撤除申请预览
import viewCancels from './views/userPages/applyCancel/viewCancels.vue'//撤除申请预览
import applyIndex from './views/userPages/applyCancel/applyIndex.vue'
import reApplyPage from './views/userPages/applyRecord/reApplyPage.vue'
import waitVerify from './views/checkerPages/waitVerify.vue'
import viewInfo from './views/checkerPages/viewInfo.vue'
import checkedList from './views/checkerPages/checkedList.vue'
import viewChecked from './views/checkerPages/viewChecked.vue'
import manageUser from './views/checkerPages/manageUser.vue'
import dataBase from './views/checkerPages/dataBase.vue'
import viewBase from './views/checkerPages/viewBase.vue'
import userLog from './views/checkerPages/userLog.vue'
import infoCount from './views/checkerPages/infoCount.vue'
import cancelInfo from './views/operatorPages/cancelInfo.vue'
import cancelInfoView from './views/operatorPages/cancelInfoView.vue'
let routes = [
    {//用户登陆
        path: '/login',
        component: Login,
        name: '',
        hidden: true,
		meta: {
			notLogin:true
		},
    },
    {//忘记密码
        path: '/forgetPwd',
        component: forgetPwd,
        name: '忘记密码',
        hidden: true,
		meta: {
			notLogin:true
		},
    },
    {// 隐私政策
        path: '/useAgreement',
        component: useAgreement,
        name: '隐私政策',
        hidden: true,
		meta: {
			notLogin:true
		},
    },

    {//用户提交撤除申请
        path: '/applyIndex',
        component: Home,
        name: '',
        iconCls: 'el-icon-location',//图标样式class
        leaf: true,//只有一个节点
        children: [
            {
                path: '/applyIndex',
                component: applyIndex,
                name: '提交撤除申请',
            },
            {
                path: '/viewCancel/:type',//撤除申请预览
                component: viewCancel,
                name: '撤除申请预览',
                meta:{
                    activeMenu:'/applyIndex'
                }
            },
            {
                path: '/viewCancels/:type',//撤除申请预览
                component: viewCancels,
                name: '撤除申请预览2',
                meta:{
                    activeMenu:'/applyIndex'
                }
            }
        ],
        redirect: '/applyIndex'
    },
     {//用户申请记录
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-menu',//图标样式class
        leaf: true,//只有一个节点
        children: [
            {
                path: '/applyRecord',
                component: applyRecord,
                name: '申请记录'

            },
            {
                path: '/viewRecord/:id/:pageType/:type/:row',//查看撤除进展详情
                component: viewRecord,
                name: 'viewRecord',
                meta: { activeMenu: '/applyRecord' },
            },//
            {
                path: '/reApplyPage/:id/:type',
                component: reApplyPage,
                name: '重新提交撤除申请',
                meta: { activeMenu: '/applyRecord' },

            },
        ],
        redirect: '/applyRecord'
    },
    //审核人路由
    {
        path: '/checkerLogin',
        component: checkerLogin,
        name: '',
        hidden: true,
		meta: {
			notLogin:true
		},
    },

    {//待审核列表
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-menu',//图标样式class
        leaf: true,//只有一个节点
        children: [
            {
                path: '/waitVerify',
                component: waitVerify,
                name: '待审核列表'

            },
            {
                path: '/viewInfo/:id',
                component: viewInfo,
                name: '撤除申请详情',
                meta:{
                    activeMenu:'/waitVerify'
                }
            }

        ],
        redirect: '/waitVerify'
    },
    {//已审核列表
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-menu',//图标样式class
        leaf: true,//只有一个节点
        children: [
            {
                path: '/checkedList',
                component: checkedList,
                name: '已审核列表'

            },
            {
                path: '/viewChecked',
                component: viewChecked,
                name: '查看撤除进展'
            }

        ],
        redirect: '/checkedList'
    },
    // 用户账号管理
   {
    path: '/',
    component: Home,
    name: '',
    iconCls: 'el-icon-menu',//图标样式class
    leaf: true,//只有一个节点
    children: [
        {
            path: '/manageUser',
            component: manageUser,
            name: '用户账号管理'

        },
    ],
    redirect: '/manageUser'
    },
    {//用户操作日志
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-menu',//图标样式class
        leaf: true,//只有一个节点
        children: [
            {
                path: '/userLog',
                component: userLog,
                name: '用户操作日志'

            },
        ],
        redirect: '/userLog'
    },
    {//信息统计
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-menu',//图标样式class
        leaf: true,//只有一个节点
        children: [
            {
                path: '/infoCount',
                component: infoCount,
                name: '信息统计'

            },
        ],
        redirect: '/infoCount'
    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-menu',//图标样式class
        leaf: true,//只有一个节点
        children: [
            {
                path: '/dataBase',
                component: dataBase,
                name: '数据库'

            },
            {
                path: '/viewBase',
                component: viewBase,
                name: '查看撤除进展'
            }

        ],
        redirect: '/dataBase'
    },
    //撤除操作人路由
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-menu',//图标样式class
        leaf: true,//只有一个节点
        children: [
            {
                path: '/cancelInfo',
                component: cancelInfo,
                name: '待处理列表'

            },
            {
                path: '/cancelInfoView/:id',
                component: cancelInfoView,
                name: '查看撤除申请',
                meta:{
                    activeMenu:'/cancelInfo'
                }
            }

        ],
        redirect: '/cancelInfo'
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true,
		meta: {
			notLogin:true
		},

    },
    {
        path: '/',
        component: Home,
        name: '',
        iconCls: 'el-icon-menu',//图标样式class
        leaf: true,//只有一个节点
        children: [
            {
                path: '/CancelPaper',
                component: CancelPaper,
                name: '撤除'


            },
        ],
        //redirect: '/CancelPaper'
    },
    // {
    //     path: '/',
    //     component: Home,
    //     name: '',
    //     iconCls: 'el-icon-menu',//图标样式class
    //     leaf: true,//只有一个节点
    //     children: [
    //         {
    //             path: '/demo',
    //             component: demo,
    //             name: '上传'


    //         },
    //     ],
    //     //redirect: '/CancelPaper'
    // },
//     {
//         path: '/',
//         component: Home,
//         name: '日志管理',
//         iconCls: 'el-icon-menu',
//         children: [
//             { path: '/SysLog', component: SysLog, name: '系统日志' },
//             { path: '/AdminLog', component: AdminLog, name: '管理员操作日志' },
//             { path: '/UserLog', component: UserLog, name: '用户使用日志' }
//         ]
//     },
//     {
//         path: '/',
//         component: Home,
//         name: '配置管理',
//         iconCls: 'el-icon-menu',
//         children: [
//             { path: '/GuidePageConfig', component: GuidePageConfig, name: '引导页配置' },
//             { path: '/IntegralConfig', component: IntegralConfig, name: '积分规则配置' },
//             { path: '/SubscribeConfig', component: SubscribeConfig, name: '订阅栏目配置' },
//         ]
//     },
//     {
//         path: '/',
//         component: Home,
//         name: '权限管理',
//         iconCls: 'el-icon-menu',
//         children: [
//             { path: '/page4', component: Page4, name: '权限组管理' },
//             { path: '/Main', component: Main, name: '权限组权限管理' },
//             { path: '/Form', component: Form, name: '权限组人员管理' }
//         ]
//     },
//     {
//         path: '/',
//         component: Home,
//         name: '账号管理',
//         iconCls: 'el-icon-menu',
//         children: [
//             { path: '/user', component: user, name: '页面4' },
//             { path: '/Form', component: Form, name: '页面5' }
//         ]
//     },
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js